import { AppConstants } from './app-constants';
export const getEnginesLinkInformation = (emissionsData, faHostServerUrl) => {
  if (
    emissionsData?.generation === '1' &&
    emissionsData?.engineSize !== '3.0L' &&
    emissionsData?.transmissionType === 'Automatic'
  ) {
    return {
      label: '1',
      url: faHostServerUrl + AppConstants.EmissionsDisclosureGen1PDF,
    };
  }

  if (
    emissionsData?.generation === '1' &&
    emissionsData?.engineSize !== '3.0L' &&
    emissionsData?.transmissionType !== 'Automatic'
  ) {
    return {
      label: '1',
      url: faHostServerUrl + AppConstants.EmissionsDisclosureGen1ManualPDF,
    };
  }

  if (
    emissionsData?.generation === '1' &&
    emissionsData?.engineSize === '3.0L' &&
    emissionsData?.subGeneration === '1'
  ) {
    return {
      label: '1',
      url: faHostServerUrl + AppConstants.EmissionsDisclosure3LGen1SubGen1PDF,
    };
  }

  if (
    emissionsData?.generation === '1' &&
    emissionsData?.engineSize === '3.0L' &&
    emissionsData?.subGeneration === '2'
  ) {
    return {
      label: '1',
      url: faHostServerUrl + AppConstants.EmissionsDisclosure3LGen1SubGen2PDF,
    };
  }

  if (
    emissionsData?.generation === '2' &&
    emissionsData?.engineSize === '3.0L' &&
    emissionsData?.subGeneration === '1'
  ) {
    return {
      label: '3.0L',
      url: faHostServerUrl + AppConstants.EmissionsDisclosure3LSubGen1PDF,
    };
  }

  if (
    emissionsData?.generation === '2' &&
    emissionsData?.engineSize === '3.0L' &&
    emissionsData?.subGeneration === '2'
  ) {
    return {
      label: '3.0L',
      url: faHostServerUrl + AppConstants.EmissionsDisclosure3LSubGen2PDF,
    };
  }

  if (
    emissionsData?.generation === '2' &&
    emissionsData?.engineSize !== '3.0L'
  ) {
    return {
      label: '2',
      url: faHostServerUrl + AppConstants.EmissionsDisclosureGen2PDF,
    };
  }

  if (emissionsData?.generation === '3') {
    return {
      label: '3',
      url: faHostServerUrl + AppConstants.EmissionsDisclosureGen3PDF,
    };
  }

  return {
    label: '',
    url: '',
  };
};
